var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconXMiniWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_969_1213",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.621094,
    y: 0.0654297,
    width: 12,
    height: 12,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_969_1213)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.94772 2.39206C3.04989 2.28989 3.21555 2.28989 3.31772 2.39206L6.62109 5.69543L9.92447 2.39206C10.0266 2.28989 10.1923 2.28989 10.2945 2.39206C10.3966 2.49423 10.3966 2.65988 10.2945 2.76206L6.99109 6.06543L10.2945 9.3688C10.3966 9.47097 10.3966 9.63663 10.2945 9.7388C10.1923 9.84097 10.0266 9.84097 9.92447 9.7388L6.62109 6.43543L3.31772 9.7388C3.21555 9.84097 3.04989 9.84097 2.94772 9.7388C2.84555 9.63663 2.84555 9.47097 2.94772 9.3688L6.2511 6.06543L2.94772 2.76206C2.84555 2.65988 2.84555 2.49423 2.94772 2.39206Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXMiniWhite);
export default __webpack_public_path__ + "static/media/icon_x_mini_white.f02c95f3fb19a5252c87b8920d565005.svg";
export { ForwardRef as ReactComponent };